<template>
    <div id="app">
        <router-view />

        <portal-target name="modals" />
    </div>
</template>

<script>
export default {
    name: "app",
    data() {
        return {};
    },
    methods: {}
};
</script>

<style lang="scss">
@import "assets/styles/tailwind.sass";
</style>
